import { render, staticRenderFns } from "./VisitMX.vue?vue&type=template&id=00ba040f&scoped=true&"
import script from "./VisitMX.vue?vue&type=script&lang=js&"
export * from "./VisitMX.vue?vue&type=script&lang=js&"
import style0 from "./VisitMX.vue?vue&type=style&index=0&id=00ba040f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ba040f",
  null
  
)

export default component.exports